"use client";

import CallbackRequestModal from "@/components/sup/callback-request-modal";
import { useAuth } from "@/hooks/use-auth";
import { useLoginDialog } from "@/hooks/use-login-dialog";
import { Phone } from "lucide-react";
import { useState } from "react";
import { PromotionalCardBase } from "../card-base";
import { PromotionalCardProps } from "../types";

export function ScheduleCallCard({ className }: PromotionalCardProps) {
	const [open, setOpen] = useState(false);
	const { isAuthenticated, user } = useAuth();
	const { openDialog } = useLoginDialog();

	const handleClick = (e?: React.MouseEvent) => {
		e?.preventDefault();
		e?.stopPropagation();
		if (!isAuthenticated) {
			openDialog({ onLoginSuccess: () => setOpen(true) });
		} else {
			setOpen(true);
		}
	};

	// We don't have projectId/unitId here as these cards are generic.
	// The modal will capture generic interest with current page URL.

	return (
		<>
			<PromotionalCardBase
				icon={<Phone className="w-full h-full" strokeWidth={1.5} />}
				title="Talk to an Expert"
				description="Have questions? Schedule a free consultation with our property experts"
				ctaText="Request Callback"
				onClick={handleClick}
				className={className}
				iconColor="text-blue-600"
			/>
			<CallbackRequestModal
				open={open}
				onClose={() => setOpen(false)}
				isAuthenticated={isAuthenticated}
				userPhoneNumbers={user?.phones?.map(p => p.number) || []}
			/>
		</>
	);
}
